import React, { useCallback, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import MaterialTableTS from "../../../../../components/tables/MaterialTableTS";
import EditButton from "../../../../../components/EditButton";
import RoleUsersViewModal from "./RoleUsersViewModal";
import { useGetRolesWithUsers } from "../hooks/useGetRolesWithUsers";
import useDeactivateRoles from "../hooks/useDeactivateRoles";
import { selectedRowsStateToDeleteOF } from "../atoms/atom";
import TextInput from "../../../../../components/TextInput";
import SaveButton from "../../../../../components/SaveButton";
import CancelButton from "../../../../../components/CancelButton";
import { useGetUsers } from "../../UsersManagement/hooks/useGetUsers";
import { accountAtom } from "../../../../Login/atoms/AccountAtom";
import AddButton from "../../../../../components/AddButton";
import ConfirmBoxDelete from "../../../../../components/ConfirmBoxDelete";
import { toast } from "../../../../../components/toastNotification";
import { useQueryClient } from "react-query";
import { Permission } from "../../Permission";

const alignCenter = "center" as
  | "center"
  | "inherit"
  | "justify"
  | "left"
  | "right"
  | undefined;
const RolesMgmtTable = () => {
  const queryClient = useQueryClient();
  const userAccount = useRecoilValue(accountAtom);
  const { data: rolesData, isLoading: getRolesLoading } =
    useGetRolesWithUsers();
  const {
    data: deactivateResult,
    mutate: BulkDeactivate,
    isSuccess: isDeactivateSuccess,
    reset: resetDeacData,
  } = useDeactivateRoles();
  const [multiUser, setMultiUser] = useState<any>([]);
  const { data: userData } = useGetUsers();
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [selectedRowsToDelete, setSelectedRowsToDelete] = useRecoilState(
    selectedRowsStateToDeleteOF
  );
  const [roleNameModal, setRoleNameModal] = useState("");
  const userOptions =
    userData &&
    userData?.map((x) => {
      return {
        value: x.accountId,
        label: x.emailAddress,
      };
    });
  const [showUserModal, setShowUserModal] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState([]);
  const [addRolePermissions, setAddRolePermissions] = useState(false);
  const [editRolePermissions, setEditRolePermissions] = useState(false);
  const [roleId, setRoleId] = useState(0);
  const [isEditRole, setIsEditRole] = useState(false);
  const [editRoleData, setEditRoleData] = useState<any>();

  const handleEdit = (row) => {
    setRoleId(row.roleId);
    setEditRoleData({
      ...row,
    });
  };
  const handleMultiSelectUser = (event) => {
    const userList = event.map((x) => x.value);

    const data = editRoleData;
    setEditRoleData({
      ...data,
      userIds: event === null ? [] : userList,
    });
    setMultiUser(event);
  };

  const handleSaveEdit = () => {
    setIsEditRole(false);
    setMultiUser([]);
    setEditRoleData([]);
  };
  const tableColumns = [
    {
      title: "Role Name",
      field: "roleName",
      render: (row) => {
        return isEditRole && row.roleId === roleId ? (
          <TextInput
            value={undefined}
            onChange={(e) => {
              const data = editRoleData;

              setEditRoleData({
                ...data,
                roleName: e.target.value,
                updatedBy: userAccount.userName,
              });
            }}
            defaultValue={row.roleName}
          />
        ) : (
          <div>{row.roleName}</div>
        );
      },
    },
    {
      title: "Users Email",
      field: "userAccounts",
      render: (row) => {
        return row.userAccounts.length > 0 ? (
          <button
            type="button"
            className="col-span-2 text-left text-primary underline"
            onClick={() => {
              setShowUserModal(true);
              setSelectedUserData(row.userAccounts);
              setRoleNameModal(row.roleName);
            }}>
            View User/s
          </button>
        ) : (
          <div className="italic text-gray-400 text-xs">No User/s</div>
        );
      },
    },
    {
      title: "Status",
      field: "isActive",
      render: (row) => (row.isActive ? "Active" : "Inactive"),
    },
    {
      title: "Action",
      field: "action",
      export: false,
      align: alignCenter,
      render: (row) => {
        return (
          <div className="w-full">
            {isEditRole && roleId === row.roleId ? (
              <div>
                <SaveButton
                  onClick={() => {
                    setIsEditRole(false);
                    setMultiUser([]);
                    setEditRoleData([]);
                  }}
                />
                <CancelButton
                  onClick={() => {
                    setIsEditRole(false);
                    setMultiUser([]);
                    setEditRoleData([]);
                  }}
                />
              </div>
            ) : (
              <div className="flex justify-center space-x-1">
                <EditButton
                  onClick={() => {
                    handleEdit(row);
                    setEditRolePermissions(true);
                    setRoleId(row.roleId);
                  }}
                  disabled={isEditRole}
                  isForLongText={true}
                  className={
                    isEditRole
                      ? "opacity-50 rounded-full items-center bg-quaternary hover:bg-tertiary text-white"
                      : "opacity-100 rounded-full items-center bg-quaternary hover:bg-tertiary text-white"
                  }
                  buttonText="Edit Role Permissions"
                />
              </div>
            )}
          </div>
        );
      },
    },
  ];
  const handleSelectedRowsChange = useCallback((rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });
    setSelectedRowsToDelete(forDelete?.map((x) => x.roleId));
  }, []);

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${
      selectedRowsToDelete?.length
    } ${
      selectedRowsToDelete
        ? selectedRowsToDelete?.length > 1
          ? "Roles"
          : "Role"
        : ""
    } ?`}</div>
  );
  const handleBulkDelete = () => {
    const ids = selectedRowsToDelete;
    BulkDeactivate(ids);
    setOpenModalDelete(false);
  };

  if (isDeactivateSuccess && deactivateResult) {
    if (deactivateResult.status === 201 || deactivateResult.status === 200) {
      toast.fire("Success", "Role were deactivated successfully", "success");
      queryClient.invalidateQueries("GetRolesWithUsers");
      setSelectedRowsToDelete([]);
    } else if (deactivateResult.status === 500) {
      if (
        deactivateResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        deactivateResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Role were successfully deactivated, but " +
            deactivateResult.data.message,
          "warning"
        );
        setSelectedRowsToDelete([]);
      } else {
        toast.fire(
          "Bulk deactivation of Role failed",
          "Server Error: Cannot deactivate Role",
          "error"
        );
      }

      queryClient.invalidateQueries("GetRolesWithUsers");
    } else {
      toast.fire(
        "Bulk deactivation of Role failed",
        "Server Error: Cannot deactivate Role",
        "error"
      );
      queryClient.invalidateQueries("GetRolesWithUsers");
    }
    resetDeacData();
  }
  return (
    <div className="">
      {!editRolePermissions && !addRolePermissions && (
        <div className="">
          <div className="text-secondary italic text-xs3 p-4">
            <p className="font-bold italic inline-block mr-1">Note: </p>
            Tick the box to deactivate some data.
            <div className="flex justify-end -mt-5">
              <AddButton
                className={"opacity-100"}
                disabled={false}
                buttonText="Add Role"
                onClick={() => {
                  setAddRolePermissions(true);
                }}
              />
            </div>
          </div>
          <div className="px-4 pb-4">
            <MaterialTableTS
              columns={tableColumns}
              data={rolesData}
              isLoading={getRolesLoading}
              toolbarSearch={true}
              showToolbar={true}
              selectedRows={selectedRowsToDelete}
              onSelectionChange={handleSelectedRowsChange}
              selection={true}
              setConfirmModalOpen={setOpenModalDelete}
            />
          </div>
        </div>
      )}
      {showUserModal && (
        <RoleUsersViewModal
          roleName={roleNameModal}
          isOpen={showUserModal}
          userData={selectedUserData}
          onClose={() => setShowUserModal(false)}
          handleMultiSelectUser={handleMultiSelectUser}
          multiUser={multiUser}
          userOptions={userOptions}
          setRoleNameModal={setRoleNameModal}
          setSelectedUserData={setSelectedUserData}
          setShowUserModal={setShowUserModal}
          handleEdit={handleEdit}
          setAddRolePermissions={setAddRolePermissions}
        />
      )}

      {(editRolePermissions || addRolePermissions) && (
        <Permission
          id={addRolePermissions ? 0 : roleId}
          permissionType="role"
          setEditPermissions={
            editRolePermissions ? setEditRolePermissions : setAddRolePermissions
          }
          isForAddingRole={addRolePermissions}
          rowData={editRoleData}
          setEditRoleData={setEditRoleData}
          handleSaveEdit={handleSaveEdit}
        />
      )}
      <ConfirmBoxDelete
        ModalTitle="Deactivate Role"
        qConfirmation={deleteMessage}
        isOpen={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        onClickFunction={handleBulkDelete}
        cancelButtonRef={undefined}
      />
    </div>
  );
};

export default RolesMgmtTable;
